import React from 'react';
import go1 from '../assets/images/goshala/go1.jpg';
import go2 from '../assets/images/goshala/go2.jpg';
import go3 from '../assets/images/goshala/go3.jpg';
import './Goshala.css';


function Goshala() {
    return (
        <section className="goshala-section">
            <div className="container">
                <br></br>
                <h1 className="goshala-title text-center">🐄 Krishna Avanti Goshala 🐄</h1>
                <br></br>

                <p>
                    Welcome to ISKCON Ujjain’s Goshalas, established by Srila Prabhupada’s dear disciple His Holiness Bhakti Charu Swami Maharaja in 2004. Starting with 6 cows, the goshala has now expanded into two locations with over 120 cattle.
                </p>

                <p>
                    Here, our primary concern is to establish the importance of cow protection along with their life long care. We also wish to provide alternatives to modern day society in regards to diet and agricultural activities. We will do this by providing education on the value of cow’s milk and the successful engagement of bulls in the fields. This will result in a simple and more natural way of life, one of non violence and self-sustenance.
                </p>

                <p>
                    The ancient scriptures teach that to take milk from the cow and then slaughter her is not at all different from killing one’s own mother. Milk, yogurt, ghee, urine and cow dung are the 5 types of pure products that the cows provide to assist in the material and spiritual progression of humankind. Taking care of the cows very lovingly, we have seen that even several years after the calf no longer depends on the milk of their mother, still the mother provides countless liters of milk.
                </p>

                <p>
                    Here in the temple goshala reside 49 cattle, 33 cows (13 of which are milking). There are 5 ox, 2 bulls, 2 male and 7 female calves. The second goshala is based a few miles away from the temple in a place known as Nalwa, where there are 79 cattle of which there are 25 cows (3 of which are milking), 2 bulls, 25 ox, 17 female and 10 male calves.
                </p>

                <p>
                    All the cattle in both farms are generously fed all day and the cows are milked at 7am and 5pm. A mixture of straw, cotton seed cakes, wheat bran and also sesame feed comprise their daily diet and the natural grass is available 6-8 months of the year. A doctor also visits both farms regularly to check the health of the cattle. Unlike modern day farms, we ensure that the relationship between the cows and their children is nourished on a daily basis.
                </p>

                <p>
                    The farm in Nalwa daily provides 2500 bundles of grass which are used to nourish the cattle at both farms. This costs around $3600 yearly to produce. The cost to feed and maintain one cow is $1.5 per day and yearly comes to around $520. Having 128 cows, the yearly feed costs around $44,000. The daily expenditure of both farms thus comes to around $190 and yearly around $69,000. This includes providing a salary for workers, general maintenance, growing grass and buying medicines etc.
                </p>

                <p>
                    We learn that God Himself loves cows. He plays with them, drinks their milk, decorates them, worships them, milks them and searches for the best grass for them to graze. Thus the Lord teaches us by example how we should take care of our mothers. Lord Krishna Himself says goṣv aṅga yavasādinā. This means that one can worship Him by offering the cow grass and other suitable grains and paraphernalia for their pleasure and health.
                </p>

                <p>
                    The Goshalas yearly donations comes to around $7,700, which is also generated from selling excess milk. With more donations we will be able to balance our income and expenditure which is of utmost importance. Furthermore we can arrange each cow to have a fixed care plan and improve all their facilities, including their bedding, fans to stop flies, pasturing grounds and a full electricity and water supply at Nalwa.
                </p>

                <p>
                    We heartily share to you an invitation to give your valuable and loving care to these cows here at ISKCON Ujjain.
                </p>
            </div>
            <div className="gallery-grid">
                <img src={go1} alt="Cow resting under tree" />
                <img src={go2} alt="Cows feeding in barn" />
                <img src={go3} alt="Devotees caring for cows" />
            </div>

        </section>
    );
}

export default Goshala;
